import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Branding } from "types";
import { apiGet } from "utilities/api";
import { SCOPES } from "utilities/constants/constants";

export const fetchCustomerBranding = createAsyncThunk(
	"groups/fetchCustomerBranding",
	apiGet<Branding>(
		(authConfig: any) => authConfig.MS_GRAPH_API_ENDPOINTS.GET_BRANDING(),
		[SCOPES.GRAPH_READ],
	),
);
